import { ref } from 'vue';

export const useToggle = (initialValue = false) => {
  const value = ref(initialValue);

  /**
   * @param {boolean} [newValue]
   */
  const toggle = (newValue) => {
    value.value = newValue !== undefined ? newValue : !value.value;
  };

  const open = () => {
    value.value = true;
  };

  const close = () => {
    value.value = false;
  };

  return {
    value,
    toggle,
    open,
    close,
  };
};

export default useToggle;
